import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import IndicatorsTypesListView from "./indicators_types-list.html";
import IndicatorsTypesEditView from "./indicators_types-edit.html";


angular.module("indicators_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('indicators_types', {
                url: "/indicators_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('indicators_types.list', {
                url: "/list",
                controller: "IndicatorsTypesListCtrl",
                template: IndicatorsTypesListView,
                data: { pageTitle: 'Indicadores' },
                requiredPermission: ["INDICATORS_TYPES_READ"]
            })
            .state('indicators_types.edit', {
                url: "/edit/:id",
                controller: "IndicatorsTypesEditCtrl",
                template: IndicatorsTypesEditView,
                data: { pageTitle: 'Indicadores' },
                requiredPermission: ["INDICATORS_TYPES_READ"]
            })
        ;
    }])
;